import { render, staticRenderFns } from "./CharlieProjectSection.vue?vue&type=template&id=52fdc5bc&scoped=true&"
import script from "./CharlieProjectSection.vue?vue&type=script&lang=js&"
export * from "./CharlieProjectSection.vue?vue&type=script&lang=js&"
import style0 from "./CharlieProjectSection.vue?vue&type=style&index=0&id=52fdc5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fdc5bc",
  null
  
)

export default component.exports